/**
 * Local dev hosts where org subdomain routing is not enforced.
 * @param {string} host
 */
function isLocalDevHost(host) {
  if (!host) return false;

  const localPatterns = [
    /^localhost(?::\d+)?$/,
    /^127\.0\.0\.1(?::\d+)?$/,
    /^local\.[^/]+(?::\d+)?$/,
  ];

  if (localPatterns.some((pattern) => pattern.test(host))) {
    return true;
  }

  const configuredOrigin = (process.env.REACT_APP_ORIGIN || '').trim();
  if (!configuredOrigin) {
    return process.env.REACT_APP_NODE_ENV === 'local';
  }

  try {
    const { hostname } = new URL(configuredOrigin);
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('local.');
  } catch {
    return process.env.REACT_APP_NODE_ENV === 'local';
  }
}

/**
 * Whether login is allowed on the current host for the user's organisation.
 * Production: org users must use their org subdomain; platform users use main origin.
 * Local dev: localhost / 127.0.0.1 / local.* hosts skip subdomain enforcement.
 *
 * @param {string|null|undefined} subDomain
 */
export function isSubdomainLoginAllowed(subDomain) {
  const host = window?.location?.host ?? '';
  const origin = window?.location?.origin ?? '';
  const configuredOrigin = (process.env.REACT_APP_ORIGIN || '').trim();
  const postfix = (process.env.REACT_APP_SUBDOMAIN_POSTFIX ?? '.machadalo.com').trim();

  if (isLocalDevHost(host)) {
    return true;
  }

  if (!subDomain) {
    return origin === configuredOrigin;
  }

  return host === `${subDomain}${postfix}`;
}
